
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLicencias"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLicencias"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fechaInicio"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fechaFin"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fechaCreacion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"estado"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"motivo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cantidadDias"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"opinionSupervisor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"observacionSupervisor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"opinionDGJP"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"observacionDGJP"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"aprobacionFase1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"aprobacionFase2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fechaEvaluacionFase1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fechaEvaluacionFase2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"organismo"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nombre"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"solicitante"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"username"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nombre"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"apellido"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"superior"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"username"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nombre"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"apellido"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":532}};
    doc.loc.source = {"body":"query getLicencias {\n  getLicencias{\n   _id,\n    fechaInicio,\n    fechaFin,\n    fechaCreacion,\n    estado,\n    motivo,\n    cantidadDias,\n    opinionSupervisor,\n    observacionSupervisor,\n      opinionDGJP,\n      observacionDGJP,\n      aprobacionFase1,\n      aprobacionFase2,\n      fechaEvaluacionFase1,\n      fechaEvaluacionFase2,\n    organismo {\n      _id\n      nombre\n    }\n    solicitante {\n      _id\n      username\n      nombre\n      apellido\n    }\n    superior {\n      _id\n      username\n      nombre\n      apellido\n    }\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getLicencias"] = oneQuery(doc, "getLicencias");
        
